import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import { LoaderButton } from 'idsk-react-components';
import Uuid from '../../model/Uuid';
import { useClient } from '../../context/ClientStatusContext';
import { assignMe } from '../../client/assignMeClient';
import { useSuccessMessageContext } from '../../context/SuccessMessageContext';
import './assignMePripomienkaButton.scss';
import Secured from '../Secured';
import UserRole from '../../model/currentuser/UserRole';
import { processInCorrectStates } from '../../function/permissions';
import LegislationProcessInfo from '../../model/currentuser/LegislationProcessInfo';

interface Props {
  pripomienkaUuid: Uuid;
  reloadPage(): void;
  reloadFilterData?(): void;
  legislationProcess: LegislationProcessInfo;
}

const AssignMePripomienkaButton = ({
  pripomienkaUuid,
  reloadPage,
  reloadFilterData,
  legislationProcess,
}: Props): ReactElement => {
  const { wrapClient: assignMeClient, status } = useClient(assignMe);
  const { displaySuccess } = useSuccessMessageContext();
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  const handleClick = async (): Promise<void> => {
    await assignMeClient(type, year, index, [pripomienkaUuid]);
    reloadPage();
    if (reloadFilterData) reloadFilterData();
    displaySuccess('Pripomienka bola úspešne priradená.');
  };
  return (
    <Secured
      allowForRoles={[UserRole.VYHODNOCOVATEL]}
      additionalCheck={processInCorrectStates(legislationProcess)}
    >
      <LoaderButton
        type="button"
        loading={status.loading}
        buttonStyle="primary"
        className="assign-me-button"
        onClick={handleClick}
        size="large"
      >
        Priradiť mne
      </LoaderButton>
    </Secured>
  );
};

export default AssignMePripomienkaButton;
